import { Form } from "@renderbus/ui";
import { FormInstance } from "antd";
import { getTranslateNsT } from "@/utils/getTranslateNsT";
import { Input, Button } from "@renderbus/ui";
import styled from "styled-components";
import { verificationCallBackFormConfig } from "../config/setting-form";
import { useChildIntergrationSettingInfo } from "../hooks/useChildIntergrationSettingInfo";
import { Tooltip } from "@renderbus/ui/components/tooltip";

export function VerificationFormDetail({ form }: { form: FormInstance }) {
  const t = getTranslateNsT("childManager");
  const { handleCopyText } = useChildIntergrationSettingInfo();
  return (
    <Form
      size={"large"}
      form={form}
      layout="vertical"
      className="verification-form"
    >
      {verificationCallBackFormConfig.map((item) => {
        return (
          <>
            {item.isShowHeader && (
              <div className="integration-item-title">
                {item.headerText}
                {item.headerTextNew && (
                  <Tooltip
                    title={item.headerTextNew}
                    trigger="hover"
                    color="#202124"
                    placement="bottomLeft"
                    tooltipText={
                      <span
                        style={{
                          color: "var(--main-color)",
                          marginLeft: "5px",
                          cursor: "pointer",
                        }}
                      >
                        新版平台
                      </span>
                    }
                  />
                )}
              </div>
            )}
            <div style={{ width: 560, margin: "auto" }}>
              <Form.Item name={item.field} label={item.title} key={item.field}>
                <VerificationFormDetailItem>
                  <Input
                    className={"dingtalk_addonafter"}
                    value={form.getFieldValue(item.field)}
                  />
                  <CopyBtn
                    onClick={() =>
                      handleCopyText(form.getFieldValue(item.field))
                    }
                  >
                    {t("dingtalk_subaccount_setting_copy_btn")}
                  </CopyBtn>
                </VerificationFormDetailItem>
              </Form.Item>
            </div>
          </>
        );
      })}
    </Form>
  );
}

const VerificationFormDetailItem = styled.div`
  display: flex;
`;
const CopyBtn = styled(Button)`
  border-top-left-radius: 0 !important;
  border-bottom-left-radius: 0 !important;
  border-color: #1c1c21 !important;
  background-color: #1c1c21 !important;
  color: var(--main-color);
  cursor: pointer;
  pointer-events: visible;
  &:hover {
    color: var(--main-color) !important;
  }
`;
